<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goTitlePage('AiSummary')"  class="title d-sm-flex pointer">
            <div class="my-auto">
              全校點數總覽
            </div>
          </div>
          <div @click="goTitlePage('AiGroupSummary')" class="title  d-sm-flex pointer">
            <div class="my-auto">
              班級點數總覽
            </div>
          </div>
          <div @click="goTitlePage('AiModify')" class="title  d-sm-flex pointer active">
            <div class="my-auto">
              點數調整
            </div>
          </div>
          <div @click="goTitlePage('AiPersonalSummary')" class="title  d-sm-flex pointer">
            <div class="my-auto">
              個人使用紀錄
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-4" style="min-height:40vh">
        <div style="text-align: right;" v-if="groupList">
          <select v-model="selected">
            <option value="0" disabled selected>請選擇班級</option>
            <option v-for="(item, index) in groupList" :key="index" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </div>
        <h4 style="text-align:left;">個人調整</h4>
        <div class="d-flex align-items-center">
          <label class="ml-2 m-0 mr-2">學員姓名:</label>
          <v-select style="width:200px" :clearable="false" v-model="studentId" :reduce="name => name.id" label="name" :options="studentList">
            <span slot="no-options">
              找不到搜尋結果
            </span>
          </v-select>
          <label class="m-0 ml-3 mr-2">點數:</label>
          <input v-model="personalPoint" type="number" name="" id="" min="0" max="99999">
          <button type="button" @click="alertPoint('personal')" class="btn mx-3 btn-primary">更新</button>
        </div>
        <br/>
        <h4 style="text-align:left;">班級統一調整</h4>
        <div style="text-align:left;">
          <label class="m-0 ml-2 mr-2">點數:</label>
          <input v-model="groupPoint" type="number" name="" id="" min="0" max="99999">
          <button @click="alertPoint('group')" type="button" class="btn mx-3 btn-primary">更新</button>
        </div>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import 'vue2-datepicker/index.css'
import api from '../../../store/api'
export default {
  name: 'Ai-Modify',
  data () {
    return {
      selected: 0,
      studentId: 0,
      studentList: [],
      groupList: [],
      personalPoint: 0,
      groupPoint: 0,
      pageCount: 10,
      pageIndex: 1
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    enterprisesId () {
      return this.$store.state.auth.enterpriseId
    }
  },
  components: {
    Pagination
  },
  watch: {
    selected (val) {
      this.$router.push({ name: 'AiModify', params:{ groupId: this.selected}})
    }
  },
  async mounted () {
    await this.getGroupList()
    await this.getStudentList()
    this.selected = this.groupId
  },
  methods: {
    async getStudentList() {
      const params = {
      page: 1,
      pageSize: 500
    }
    const { data } = await api.get(`groups/${this.groupId}/students`, { params })
    this.studentList = data.data
    this.studentId = data.data[0].id
    },
    async modifyPoint (decide) {
      let point = 0
      const fileData = new window.FormData()
      if (decide==='personal') {
        fileData.append('student_id', this.studentId)
        point = this.personalPoint
      } else {
        point = this.groupPoint
      }
      try {
        fileData.append('points', point)
        const { data } = await api.post(`enterprises/${this.enterprisesId}/groups/${this.groupId}/points`, fileData)
        this.$swal({
          title: '已更新點數',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
      } catch (error) {
        if (error) {
          this.$swal({
            title: error.response.data.message,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: '確定'
          })
        }
      }
    },
    async alertPoint (decide) {
      let self = this
      self.$swal({
        title: '確認修改點數嗎?',
        showCancelButton: true,
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        closeOnConfirm: false
      }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          self.modifyPoint(decide)
        }
      })
    },
    async getGroupList() {
      const { data } = await api.get(`enterprises/${this.enterprisesId}/groups?pageSize=100000`)
      this.groupList = data.data
    },
    goTitlePage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/color.scss";
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  .pop-box {
    width: 500px !important;
  }
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .active {
    // color: red;
    font-weight: bolder;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
